import React, { useState } from "react";
import __ from "lodash";
import moment from "moment";
import {validateEmail} from "../../../functions/EmailValidation";
import Alert from "../../../controls/Alert";

const UpdateSlotValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;


  if (!error && (!record.coordinatorResponse || record.coordinatorResponse === "" )) {
    error = true;
    errorMessage = "'Coordinator\' Response' is required";
    id = "coordinatorResponse";
  }

  if (!error && !record.reason ) {
    error = true;
    errorMessage = "'Reason for Manual Update' is required";
    id = "reason";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default UpdateSlotValidator;
